module.exports = __webpack_public_path__ + "media/images/badge/a-bersaglio_secondary-a895c1710d95c287c10d34f4c00c1fdf.png";